import { IonButton, IonInput } from '@ionic/react';
import React, { KeyboardEvent, useRef, useState } from 'react';

import { ButtonContainer, Spacer } from '@/components/common';
import { Icon } from '@/components/memo';
import { useGetStarted } from '@/contexts';
import { useInputFocus, useToast } from '@/hooks';
import { GET_STARTED_STEPS } from '@/utils/constants';
import { arrowForwardCircleOutline } from 'ionicons/icons';

import './ClinicName.css';

const ClinicName: React.FC = () => {
  const { clinicName, setClinicName, setCurrentStep } = useGetStarted();
  const displayToast = useToast();
  const [hasError, setHasError] = useState<boolean>(false);
  const inputRef = useRef<HTMLIonInputElement>(null);

  useInputFocus(inputRef);

  const copy = {
    subHeader: "ENTER YOUR CLINIC'S NAME",
    header: (
      <>
        What's the <span>name</span> of your clinic?
      </>
    ),
    buttonText: 'Next'
  };

  const onInput = (event: CustomEvent) => {
    setClinicName(event.detail.value!);
    setHasError(false);
  };

  const onNext = () => {
    if (clinicName && clinicName.trim()) {
      setHasError(false);
      setCurrentStep(GET_STARTED_STEPS.MOBILE_NUMBER);
    } else {
      setHasError(true);
      displayToast({
        message: 'Please enter a valid clinic name.',
        duration: 5000,
        position: 'bottom',
        positionAnchor: 'next-button'
      });
    }
  };

  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      onNext();
    }
  };

  return (
    <div className="clinic-name">
      <Spacer top={32} bottom={24}>
        <h4 className="clinic-name__sub-header">{copy.subHeader}</h4>
        <h1 className="clinic-name__header">{copy.header}</h1>
      </Spacer>

      <Spacer bottom={102}>
        <div className="clinic-name__form">
          <div
            className={`clinic-name__input ${hasError ? 'clinic-name__input--error' : ''}`}
          >
            <IonInput
              ref={inputRef}
              label="Clinic Name"
              labelPlacement="stacked"
              value={clinicName}
              placeholder="Enter the name of your clinic"
              onIonInput={onInput}
              onKeyDown={onKeyDown}
              autoFocus={true}
            />
          </div>
        </div>
      </Spacer>
      <ButtonContainer>
        <IonButton
          id="next-button"
          onClick={onNext}
          expand="block"
          fill="solid"
          size="default"
          color="primary"
          strong={true}
        >
          <Icon slot="start" icon={arrowForwardCircleOutline} />
          {copy.buttonText}
        </IonButton>
      </ButtonContainer>
    </div>
  );
};

export default ClinicName;
